import * as React from "react";
const CheckIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="frame" clipPath="url(#clip0_15123_3658)">
      <path
        id="vector"
        d="M5.2 10.9792L7.16 13.7608C7.23435 13.8719 7.33414 13.9635 7.45108 14.0282C7.56801 14.0929 7.69871 14.1288 7.8323 14.1328C7.96588 14.1368 8.09848 14.1088 8.21907 14.0512C8.33967 13.9936 8.44476 13.908 8.5256 13.8016L14.8 5.8632M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z"
        stroke="#286271"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_15123_3658">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default CheckIcon;
